import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic will be added here
    console.log('Form submitted:', formData);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="py-24 bg-[#0A1628]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16">
          {/* Left Column - Contact Form */}
          <div>
            <div className="bg-white rounded-3xl p-6 sm:p-10 lg:p-12">
              <h3 className="text-4xl font-black text-[#0A1628] mb-8">
                Get In Touch
              </h3>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full bg-gray-100 border-0 rounded-xl px-6 py-4 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#FF6B35]"
                    required
                  />
                </div>

                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full bg-gray-100 border-0 rounded-xl px-6 py-4 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#FF6B35]"
                    required
                  />
                </div>

                <div>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Your Phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full bg-gray-100 border-0 rounded-xl px-6 py-4 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#FF6B35]"
                  />
                </div>

                <div>
                  <textarea
                    name="message"
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={5}
                    className="w-full bg-gray-100 border-0 rounded-xl px-6 py-4 text-gray-800 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#FF6B35] resize-none"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-[#FF6B35] text-white py-4 rounded-full font-bold text-lg hover:bg-[#ff5722] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>

          {/* Right Column - Info & Map */}
          <div className="space-y-8">
            {/* Contact Details */}
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#FF6B35] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <div className="ml-6">
                  <h4 className="text-white font-bold mb-1">Phone</h4>
                  <p className="text-white/80 text-lg">(810) 354-8352</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#FF6B35] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-white text-xl"></i>
                </div>
                <div className="ml-6">
                  <h4 className="text-white font-bold mb-1">Email</h4>
                  <p className="text-white/80 text-lg">staff@tricountyninja.com</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#FF6B35] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div className="ml-6">
                  <h4 className="text-white font-bold mb-1">Address</h4>
                  <p className="text-white/80 text-lg">
                    14283 Fenton Rd<br />
                    Fenton, MI 48430
                  </p>
                </div>
              </div>
            </div>

            {/* Hours */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 sm:p-8">
              <h4 className="text-[#FF6B35] text-sm font-bold uppercase tracking-wider mb-4">
                Hours
              </h4>
              <div className="space-y-3 text-white text-sm sm:text-base">
                <div className="flex flex-col sm:flex-row sm:justify-between gap-1">
                  <span className="text-white/80">Mon, Wed – Fri</span>
                  <span className="font-semibold">12:00 PM – 8:30 PM</span>
                </div>
                <div className="flex flex-col sm:flex-row sm:justify-between gap-1">
                  <span className="text-white/80">Tuesday</span>
                  <span className="font-semibold">12:00 PM – 8:00 PM</span>
                </div>
                <div className="flex flex-col sm:flex-row sm:justify-between gap-1">
                  <span className="text-white/80">Saturday – Sunday</span>
                  <span className="font-semibold">12:00 PM – 6:00 PM</span>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="rounded-2xl overflow-hidden border border-white/20 h-64 sm:h-80">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2926.47025107674!2d-83.70866412271792!3d42.8206795058749!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882365c6c572e39b%3A0xb759970161ce4ac6!2sTri%20County%20Ninja%20%26%20Collectibles!5e0!3m2!1sen!2sus!4v1776268552603!5m2!1sen!2sus" width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </div>

        {/* Bottom CTA Row */}
        <div className="flex flex-wrap justify-center gap-6 mt-16">
          <button className="bg-[#FF6B35] text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-[#ff5722] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer">
            View Schedule in Vagaro
          </button>
          <button className="bg-transparent border-2 border-white text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#0A1628] transition-all duration-300 whitespace-nowrap cursor-pointer">
            Book Through Vagaro
          </button>
        </div>
      </div>
    </section>
  );
}